<template>
  <div @click="updateQty">
    <b-form-spinbutton v-model="value" min="1" v-bind:max="stock" v-bind:value="qty"></b-form-spinbutton>
  </div>
</template>

<script>
export default {
  name: 'ButtonPlusMinus',
  props: ['qty', 'stock', 'IdProd'],
  data () {
    return {
      value: 0
    }
  },
  methods: {
    updateQty () {
      console.log(this.value, this.IdProd, '<<< value, IdProd')
      this.$store.dispatch('updateQty', {
        value: this.value,
        IdProd: this.IdProd
      })
    },
    checkValue () {
      if (this.qty > this.stock) {
        this.value = this.stock
      } else {
        this.value = this.qty
      }
    }
  },
  created () {
    this.checkValue()
  }
}
</script>

<style>

</style>
